export default __webpack_public_path__ + "static/media/iname.2c2721dd.jpg";